import { render, staticRenderFns } from "./TaskDropSumFields.vue?vue&type=template&id=8a566bae&"
import script from "./TaskDropSumFields.vue?vue&type=script&lang=js&"
export * from "./TaskDropSumFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports